var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customers-page',{ref:"customersPage",attrs:{"export-loading":_vm.exportLoading},on:{"export-customers":_vm.getCsvReport,"get-customers":_vm.fetchData}})
}
var staticRenderFns = []

export { render, staticRenderFns }